import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Cpu, ShieldCheck } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      <div className="flex-1 flex flex-col justify-center px-8 sm:px-16 lg:px-24 bg-white">
        <div className="max-w-md w-full mx-auto">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
              <Cpu className="w-6 h-6 text-white" />
            </div>
            <span className="text-2xl font-cabinet font-black tracking-tight text-gray-900">WERT AI</span>
          </div>
          <h1 className="text-4xl font-cabinet font-black tracking-tighter text-gray-900 mb-3">
            TriageOS
          </h1>
          <p className="text-lg text-gray-500 font-ibm mb-2">
            Pre-Dispatch Intelligence for Industrial Field Service
          </p>
          <p className="text-sm text-gray-400 font-ibm mb-10">
            Reduce repeat truck rolls. Improve first-time fix rates. Make every dispatch count.
          </p>
          <button
            data-testid="google-login-btn"
            onClick={login}
            className="w-full flex items-center justify-center gap-3 bg-gray-900 text-white px-6 py-3.5 rounded-lg font-ibm font-medium hover:bg-gray-800 transition-all duration-200 shadow-sm hover:shadow-md"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
            Sign in with Google
          </button>
          <div className="mt-8 flex items-center gap-2 text-xs text-gray-400">
            <ShieldCheck className="w-4 h-4" />
            <span className="font-ibm">Enterprise-grade security. GDPR compliant.</span>
          </div>
        </div>
      </div>
      <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 to-blue-900" />
        <div className="absolute inset-0 opacity-10" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1738162837329-2f2a2cdebb5e?w=800)', backgroundSize: 'cover', backgroundPosition: 'center'}} />
        <div className="relative z-10 flex flex-col justify-end h-full p-12 text-white">
          <p className="text-xs font-ibm-mono uppercase tracking-[0.25em] text-blue-300 mb-4">Powered by TriageOS</p>
          <h2 className="text-3xl font-cabinet font-bold mb-4">
            28% of service visits require a repeat.
          </h2>
          <p className="text-lg text-blue-200 font-ibm">
            TriageOS ensures only ready-to-fix jobs get dispatched.
          </p>
        </div>
      </div>
    </div>
  );
}
